import React, { Component } from "react";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import Strings from "@my-dld/assets/strings";
import { RDCCaseProps } from "./RDCCaseListView";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { RDCCase } from "../../rdcapi/entities";
import { getCaseNumber, getCaseStatus, getCaseStatusColor, getCaseType, getClosureDate, getRegistrationDate } from "./index";

interface State {
	searchKey?: string;
	page: number;
}

class RDCCaseGridView extends Component<RDCCaseProps, State> {
	constructor( props: RDCCaseProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { items } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: RDCCase ) => {
				return <RenderGridItem
					key={ item.caseNo }
					item={ item }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: RDCCase ) => {
				const filterKeys: string[] = [];
				filterKeys.push( item.caseNo );
				filterKeys.push( item.caseStatusEn );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: RDCCase[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: { item: RDCCase } ) {
	const { item } = props;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getCaseNumber( item ) }</span>
							<span>{ Strings.case_number }</span>
						</div>
						<div className={ "property-status " + getCaseStatusColor( item ) }>
							{ getCaseStatus( item ) }
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-4">
							<span>{ getCaseType( item ) }</span>
							<span>{ Strings.case_type }</span>
						</div>
						<div className="col-4">
							<span>{ getRegistrationDate( item ) }</span>
							<span>{ Strings.registration_date }</span>
						</div>
						<div className="col-4">
							<span>{ getClosureDate( item ) }</span>
							<span>{ Strings.closure_date }</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default RDCCaseGridView;
